import component from './referrals.component';
import list from './list/list.component';

export default angular.module('mpdx.home.referrals', [list, component]).name;
